import Projects from "./Projects";

const Portfolio = () => {
  return (
    <section id="portfolio" className="bg-primary py-24">
      <div className="container mx-auto max-w-6xl">
        <div className="mb-16 text-center">
          <p className="text-accent uppercase tracking-widest text-sm mb-4">
            Proyectos seleccionados
          </p>

          <h2 className="text-3xl md:text-4xl font-bold mb-6">
            Sistemas diseñados con enfoque estructural
          </h2>

          <p className="text-paragraph max-w-2xl mx-auto leading-relaxed">
            Casos donde el foco no fue solo implementar funcionalidades, sino
            definir arquitectura, modelar dominio y tomar decisiones técnicas
            con impacto real.
          </p>
        </div>

        <Projects />
      </div>
    </section>
  );
};

export default Portfolio;
